export const REPORT_LIST = 'REPORT/list';
export const REPORT_PAGER = 'REPORT/pager';
export const REPORT_FILTER = 'REPORT/filter';
export const REPORT_GENERATE = 'REPORT/generate';
